import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        color: theme.palette.secondary.main,
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '0 20px 0 20px',
        textAlign: 'center'
    },
    title: {
        height: 130,
        marginTop: 100,
    },
    infoText: {
        fontSize: 18,
        fontWeight: 'bold'
    },
    savingInfo: {
        height: 300,
        fontSize: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    footer: {
        marginTop: 'auto',
        paddingBottom: theme.spacing(2),
        width: '100%',
        '& .MuiButton-root': {
            width: '75%'
        }
    }
}));

export default useStyles;
